/**
 * AP-10 — FM-WIN-19: CANopen-Detailfenster.
 *
 * Titel `"<Name> (COB-ID 0x<id>)"` (CanopenDetailWindow.cpp:35), ein Fenster je
 * COB-ID (`frame.id & 0x7FF`) — dieselbe Schluesselung wie
 * `canopenDetailWindows_` im Original (CanMonitorApp.cpp:2696-2704).
 */

import { createDetailWindow, type DetailWindowHandle } from './detailWindow';

export function createCanopenDetailWindow(cobId: number, name: string): DetailWindowHandle {
  const title = `${name === '' ? 'CANopen' : name} (COB-ID 0x${cobId.toString(16).toUpperCase().padStart(3, '0')})`;
  return createDetailWindow(title);
}
